<template>
  <base-form :title="$t('settings.email-schedule.edit', {name: model.subject})"
             :loading="loading"
             :disabled="model.id"
             @submit="onSubmit"
             class="email-schedule">
    <fg-input :error="getError($t('generic.name'))"
              :label="$t('generic.name')"
              :disabled="model.id"
              v-model="model.name"
              v-validate="'required'"
              :name="$t('settings.emails-schedule.name')"
              required
    />

    <fg-input :error="getError($t('settings.emails-schedule.template'))"
              :disabled="model.id"
              :label="$t('settings.emails-schedule.template')"
              required>
      <email-template-autocomplete v-model="model.email_template_id"
                                   v-validate="'required'"
                                   @value-change="selectedEmailTemplate = $event"
                                   :disabled="model.id"
                                   :name="$t('settings.emails-schedule.template')"
      />
    </fg-input>

    <fg-input :error="getError($t('settings.emails-schedule.timeFrameOrigin'))"
              :disabled="model.id"
              :label="$t('settings.emails-schedule.timeFrameOrigin')"
              required
    >
      <el-select v-model="model.time_frame_origin"
                 v-validate="'required'"
                 :disabled="model.id"
                 :name="$t('settings.emails-schedule.timeFrameOrigin')"
                 class="select-default"
      >
        <el-option v-for="option in timeframeTypes"
                   v-bind="option"
                   :key="option.value"
                   class="select-default"
        />
      </el-select>
    </fg-input>

    <fg-input :error="getError($t('settings.emails-schedule.targetEvent'))"
              :disabled="model.id"
              :label="$t('settings.emails-schedule.targetEvent')"
              required
    >
      <el-select v-model="model.target_event"
                 v-validate="'required'"
                 :disabled="model.id"
                 :name="$t('settings.emails-schedule.targetEvent')"
                 class="select-default"
      >
        <el-option v-for="option in targetEventTypes"
                   v-bind="option"
                   :key="option.value"
                   class="select-default"
        />
      </el-select>
    </fg-input>

    <fg-input type="number"
              :error="getError($t('settings.emails-schedule.delayMinutes'))"
              :label="$t('settings.emails-schedule.delayMinutes')"
              :disabled="model.id"
              v-model="model.delay_minutes"
              v-validate="'required'"
              :name="$t('settings.emails-schedule.delayMinutes')"
              required
    />

    <fg-input :error="getError($t('settings.emails-schedule.frequency'))"
              :label="$t('settings.emails-schedule.frequency')"
              :disabled="model.id"
              required
    >
      <el-select v-model="model.frequency_option"
                 v-validate="'required'"
                 :disabled="model.id"
                 :name="$t('settings.emails-schedule.frequency')"
                 class="select-default"
      >
        <el-option v-for="option in frequencyOptions"
                   v-bind="option"
                   :key="option.value"
                   class="select-default"
        />
      </el-select>
    </fg-input>

  </base-form>
</template>
<script>
import EmailScheduleService from 'src/services/EmailScheduleService'
import EmailTemplateService from '@/services/EmailTemplateService'
import EmailTemplateAutocomplete from '@/components/Autocomplete/EmailTemplateAutocomplete'
import { Select, Option } from 'element-ui'

export default {
  name: 'email-edit',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    EmailTemplateAutocomplete,
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedEmailTemplate: null,
      model: {
        name: '',
        email_template_id: 1,
        delay_minutes: 60,
        time_frame_origin: 'before',
        target_event: 'job_ends',
        frequency_option: 'single'
      },
    }
  },
  computed: {
    frequencyOptions () {
      return [
        {
          value: 'single',
          label: this.$t('generic.single'),
        },
        {
          value: 'hourly',
          label: this.$t('generic.hourly'),
        },
        {
          value: 'daily',
          label: this.$t('generic.daily'),
        },
        {
          value: 'weekly',
          label: this.$t('generic.weekly'),
        }
      ]
    },
    targetEventTypes () {
      return [
        {
          value: 'job_starts',
          label: this.$t('settings.email-schedule.jobStarts'),
        },
        {
          value: 'job_ends',
          label: this.$t('settings.email-schedule.jobEnds'),
        },
      ]
    },
    timeframeTypes () {
      return [
        {
          value: 'before',
          label: this.$t('generic.before'),
        },
        {
          value: 'after',
          label: this.$t('generic.after'),
        },
      ]
    },
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        if (!value) {
          return
        }
        this.model = {
          ...this.model,
          ...value,
        }
      }
    }
  },
  methods: {
    async onSubmit () {
      if (this.model.id) {
        return
      }
      let valid = await this.$validator.validateAll()
      if (valid) {
        try {
          const emailTemplate = {
            ...this.selectedEmailTemplate
          }
          delete emailTemplate.id
          await EmailTemplateService.create({
            name: this.selectedEmailTemplate.name,
            subject: this.selectedEmailTemplate.subject,
            content: this.selectedEmailTemplate.content,
            type: 'automation'
          })
          this.loading = true
          const data = {
            ...this.model,
            delay_option: 'days',
            delay_count: 1
          }
          await EmailScheduleService.create(data)
          this.$notify({ type: 'success', message: this.$t('settings.emails-schedule.create.success')})
        } finally {
          this.loading = false
        }
      }
    },
  }
}
</script>
<style lang="scss">
</style>
